import axios from 'axios';



/**
 * 获取信用分商品列表
 * @returns {json}
 */
export const getList = params => {
  return axios.get('/web-nbcc/commodity/commodity/list3',{params : params});
};













// WEBPACK FOOTER //
// ./src/api/credit_score/index.js